import React, { useEffect, useState } from 'react'
import axios from 'lib/axios'
import PluginSlot from 'components/utility/PluginSlot'
import ComplianceFormSkeleton from 'components/ny1120b/ComplianceForm/ComplianceFormSkeleton'

export default function TopComponents({ packageHashedId, hasComponents, showComplianceFormSkeleton }) {
  const [components, setComponents] = useState(null)

  useEffect(() => {
    if (!hasComponents) return

    axios.get(`/packages/${packageHashedId}/data`)
      .then(({ data }) => setComponents(data.top_components || []))
      .catch(() => setComponents([]))
  }, [packageHashedId, hasComponents])

  if (!hasComponents) return null
  // ComplianceFormSkeleton is specific to the compliance form, so it only renders
  // while loading if the server told us the compliance form is actually among the
  // components being fetched — a future second contributor needs its own skeleton
  // and its own showXSkeleton flag rather than reusing this one.
  if (components === null) return showComplianceFormSkeleton ? <ComplianceFormSkeleton /> : null
  if (components.length === 0) return null

  return (
    <div className="requirements-top-components">
      {components.map(({ component, props }) => (
        <PluginSlot key={component} component={component} props={props} />
      ))}
    </div>
  )
}
